"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DecileRanks = void 0;
exports.DecileRanks = [
    {
        label: 'Top 10% for 25+% courses',
        value: 'top10for25',
    },
    {
        label: 'Top 10% for 50+% courses',
        value: 'top10for50',
    },
    {
        label: 'Top 10% for 80+% courses',
        value: 'top10for80',
    },
    {
        label: 'Top 10% for 100% courses',
        value: 'top10for100',
    },
    {
        label: 'Top 1% of students in my year',
        value: 'rank1',
    },
    {
        label: 'Top 3% of students in my year',
        value: 'rank11',
    },
    {
        label: 'Top 5% of students in my year',
        value: 'rank2',
    },
    {
        label: 'Top 10% of students in my year',
        value: 'rank3',
    },
    {
        label: 'Top 15% of students in my year',
        value: 'rank4',
    },
    {
        label: 'Top 20% of students in my year',
        value: 'rank5',
    },
    {
        label: 'Top 30% of students in my year',
        value: 'rank6',
    },
    {
        label: 'Top 50% of students in my year',
        value: 'rank8',
    },
    {
        label: 'Top 75% of students in my year',
        value: 'rank9',
    },
    {
        label: 'Unsure',
        value: 'rank10',
    },
    {
        label: 'Other - specify',
        value: 'rank7',
    },
];
//# sourceMappingURL=decileRanks.js.map